export default "__VITE_ASSET__DImqoZ12__"